import {
  isInArticleAdUnit,
  isStandardBannersAdUnit
} from '../../../../common/js/adUnit';
import {
  AfterVideoLoadedEvent,
  FormatContext,
  ILoadingStrategy
} from './loading-strategy';

export class CtaEndScreenStrategy implements ILoadingStrategy {
  isRunnable(formatContext: FormatContext): boolean {
    return (
      isInArticleAdUnit(formatContext.adContext.adUnitType || '') ||
      isStandardBannersAdUnit(formatContext.adContext.adUnitType || '')
    );
  }

  afterVideoLoaded(event: AfterVideoLoadedEvent): AfterVideoLoadedEvent {
    return event;
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    formatContext.config = {
      ...formatContext.config,
      closeBtn: {
        ...formatContext.config.closeBtn,
        autoCloseDelay: Infinity
      }
    };

    return formatContext;
  }
}
